// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__84wh_","errorLogs":"styles_errorLogs__Whl8M"};